var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_586_681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 11.0001C22 14.4887 20.376 17.5981 17.8426 19.6132C15.9645 21.1076 13.5869 22 11.0001 22C8.41316 22 6.03562 21.1076 4.15742 19.6132C1.62411 17.5981 0 14.4887 0 11.0001C0 4.92499 4.9251 0 11.0001 0C17.075 0 22 4.92499 22 11.0001Z",
    fill: "#4C56C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 14.507C13.3614 14.507 15.2754 12.593 15.2754 10.2319C15.2754 7.87081 13.3614 5.95679 11.0003 5.95679C8.63925 5.95679 6.72522 7.87081 6.72522 10.2319C6.72522 12.593 8.63925 14.507 11.0003 14.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.842 19.6134C15.9639 21.1078 13.5864 22.0002 10.9995 22.0002C8.41261 22.0002 6.03507 21.1078 4.15686 19.6134C5.53219 17.593 8.08183 16.2361 10.9995 16.2361C13.9172 16.2361 16.467 17.5927 17.842 19.6134Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_586_681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatar);
export default __webpack_public_path__ + "static/media/Profile Avatar.ed45be6935ab6d61c05fe4d7651f6df9.svg";
export { ForwardRef as ReactComponent };